import { IGetItemsParams } from '../types/IGetItemsParams';
import { IGetItemsResult } from '../types/IGetItemsResult';
import { ISiteNameWithId } from '../types/ISiteNameWithId';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IGetSiteNamesResult extends IGetItemsResult {
  siteNames: ISiteNameWithId[];
}

export class GetSiteNamesRequest extends Request<IGetItemsParams, IGetSiteNamesResult> {
  constructor(params: IGetItemsParams) {
    super('getSiteNames', params);
  }
}
